import AIIcon from './AIIcon';

export default AIIcon;
